module.exports = __webpack_public_path__ + "static/media/img3.1113e581.jpg";